import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { Button, Tabs } from "antd";
import { useNavigate } from "react-router-dom";
import { useHasAccess } from "~/Hooks/useHasAccess";
import GroundHoldersPageContent from "./GroundHoldersPageContent";
import { GroundHoldersPageHeading } from "./GroundHoldersPageHeading";
import { GroundHandlersNextPage } from "./GroundHandlersNextPage";
export const GroundHolders = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const { openToast } = useNotification();
  const { hasRole } = useHasAccess();

  const items = [
    {
      label: "Page Heading",
      key: "groundHandlersPageHeading",
      children: <GroundHoldersPageHeading/>
    }, 
    {
      label: "Page Content",
      key: "groundHandlersPageContent",
      children: <GroundHoldersPageContent/>
    },
    {
      label: "Next Page",
      key: "groundHandlersNextPage",
      children: <GroundHandlersNextPage/>
    },
  ];

  return (
    <>
      <Tabs
        activeKey={query?.get("subActiveTab") || ""}
        items={items}
        onChange={(activeKey) => {
          navigate(`${window.location.pathname}?activeTab=${query.get("activeTab")}&subActiveTab=${activeKey}`, { replace: true });
        }}
      ></Tabs>
    </>
  );
};
